// extracted by mini-css-extract-plugin
module.exports = {"MenuRoot":"Menu_MenuRoot__16Z2E","MenuPaper":"Menu_MenuPaper__2Tgeg"};